import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const WelcomeSection = () => (
    <Card style={{ marginBottom: '24px' }}>
        <Title level={3}>Welcome to Trading Terminal Journal</Title>
        <Paragraph>
            The Journal helps you track, analyze, and learn from your trading activities. Whether
            you&apos;re using our Trading Terminal Simulator for practice or managing funded
            accounts, the Journal automatically integrates with your trading data to provide
            comprehensive insights.
        </Paragraph>
        <Paragraph>
            <strong>TT Simulator Integration:</strong> Your simulator trades are automatically
            synced with the Journal, allowing you to practice trading strategies and review
            performance without risking real capital.
        </Paragraph>
    </Card>
);

export default WelcomeSection;
